var getFileSource = function (image) {
    return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function (event) { var _a; return resolve(((_a = event.target) === null || _a === void 0 ? void 0 : _a.result) || null); };
        reader.onerror = reject;
        reader.readAsDataURL(image);
    });
};
export default getFileSource;
//# sourceMappingURL=getFileSource.js.map